import { Flex, Text } from '@chakra-ui/react'

const Ingredient = () => {
  return (
    <Flex
      w="100%"
      mt={{
        base: '30px'
      }}
      flexDir="column"
      alignItems="center"
      justifyContent="center"
    >
      <Text
        textStyle="oralcareOptimizingTitle"
        textAlign="center"
        textTransform="uppercase"
        w="100%"
        color="white"
        mt={{
          base: '1px',
          sm: '10px',
          md: '10px',
          lg: '10px'
        }}
      >
        Ingredients
      </Text>
      <Text
        textStyle="oralcareOptimizingContent"
        textAlign="center"
        fontWeight={400}
        w="100%"
        color="white"
        mt={{
          base: '1px',
          sm: '10px',
          md: '10px',
          lg: '10px'
        }}
      >
        Jeju citrus extract, red ginseng extract, rosemary extract , peppermint
        oil, propolis extract
      </Text>
    </Flex>
  )
}

export default Ingredient
